var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagJoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C6.04641 0 7.7339 1.53675 7.9714 3.51918C9.18274 4.20618 10 5.50765 10 7C10 9.20914 8.20914 11 6 11C3.95359 11 2.2661 9.46325 2.0286 7.48082C0.817257 6.79383 0 5.49235 0 4C0 1.79086 1.79086 0 4 0ZM7.93733 4.70934L7.92351 4.78244C7.55971 6.61698 5.94136 8 4 8C3.70481 8 3.41708 7.96802 3.1401 7.90735C3.5241 9.12061 4.65935 10 6 10C7.65685 10 9 8.65685 9 7C9 6.08163 8.58734 5.25964 7.93733 4.70934ZM6 4C4.46149 4 3.19348 5.15812 3.02018 6.65014L3.00504 6.83107C3.31639 6.94049 3.65125 7 4 7C5.53851 7 6.80652 5.84188 6.97982 4.34986L6.99496 4.16893C6.68361 4.05951 6.34875 4 6 4ZM4 1C2.34315 1 1 2.34315 1 4C1 4.91837 1.41266 5.74036 2.06267 6.29066C2.39769 4.41972 4.03305 3 6 3C6.29519 3 6.58292 3.03198 6.8599 3.09265C6.4759 1.87939 5.34065 1 4 1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagJoinIcon);
export default __webpack_public_path__ + "static/media/tag-join-icon.c976e704fa5bf1c457900236cb8fabe4.svg";
export { ForwardRef as ReactComponent };